import React from 'react'
import clsx from 'clsx'
import { ButtonProps } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

import Button from './Button'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    fontSize: theme.size.sm,
    color: '#323436',
    background: 'none',
    backgroundColor: '#E6EAEC',

    '&:hover': {
      backgroundColor: '#E6EAEC'
    }
  }
}))

const GreyButton: React.FC<ButtonProps> = ({ className, ...props }) => {
  const classes = useStyles()

  return <Button className={clsx(classes.root, className)} {...props} />
}

export default GreyButton
